<template>
	<div class="border-connectProBlue border-2 pl-8 pr-8 pb-8 pt-4 rounded min-h-72">
		<div class="flex space-x-16 border-b-2 pb-5">
			<div
				v-if="allowCustomerTab"
				:class="{ active: tab === 'customer' }"
				class="tab"
				@click="
					tab = 'customer';
					fetchDocuments();
				"
			>
				{{ $t('customer') }}
			</div>
			<div
				v-if="allowDamageAssessorTab"
				:class="{ active: tab === 'damageassessor' }"
				class="tab"
				@click="
					tab = 'damageassessor';
					fetchDocuments();
				"
			>
				{{ $t('damage_assessor') }}
			</div>
			<div
				v-if="allowRepairShopTab"
				:class="{ active: tab === 'repairshop' }"
				class="tab"
				@click="
					tab = 'repairshop';
					fetchDocuments();
				"
			>
				{{ $t('repair_shop') }}
			</div>
			<div
				v-if="allowLawyerTab"
				:class="{ active: tab === 'lawyer' }"
				class="tab"
				@click="
					tab = 'lawyer';
					fetchDocuments();
				"
			>
				{{ $t('lawyer') }}
			</div>
			<div
				:class="{ active: tab === 'misc' }"
				class="tab"
				@click="
					tab = 'misc';
					fetchDocuments();
				"
			>
				{{ $t('other') }}
			</div>
		</div>

		<ProcessDocumentCardTab
			v-if="tab === 'repairshop' && allowRepairShopTab"
			:documents="$store.getters.getDocumentsRepairShop"
			:title="$store.getters.repairShopLabel"
		/>
		<ProcessDocumentCardTab v-if="tab === 'customer' && allowCustomerTab" :documents="$store.getters.getDocumentsCustomer" title="Kunde" />
		<ProcessDocumentCardTab
			v-if="tab === 'damageassessor' && allowDamageAssessorTab"
			:documents="$store.getters.getDocumentsDamageAssessor"
			:title="$t('damage_assessor').toString()"
		/>
		<ProcessDocumentCardTab
			v-if="tab === 'lawyer' && allowLawyerTab"
			:documents="$store.getters.getDocumentsLawyer"
			:is-system-lawyer="this.process.lawyerOffice.is_system_partner"
			:title="$t('lawyer').toString()"
		/>
		<ProcessDocumentCardTab
			v-if="tab === 'misc'"
			:documents="$store.getters.getDocumentsMisc"
			:enable-add-button="true"
			:title="$t('other').toString()"
			@add="add"
		/>
	</div>
</template>

<script>
import ProcessDocumentCardTab from '@/views/management/Process/Document/ProcessDocumentCardTab';
import Authentication from '@/mixins/Authentication';

export default {
	name: 'ProcessDocumentUploadTab',
	components: { ProcessDocumentCardTab },
	props: {
		isSystemDamageAssessor: { default: true },
	},
	mixins: [Authentication],
	data() {
		return {
			tab: 'customer',
		};
	},
	mounted() {
		if (this.isUserAllowedInLevel2) {
			this.tab = 'damageassessor';
		} else if (this.isUserAllowedInLevel5or6) {
			this.tab = 'repairshop';
		} else if (this.isUserAllowedInLevel3) {
			this.tab = 'lawyer';
		}
	},
	computed: {
		isOrderDocumentation() {
			return this.process?.process_type === 'order_documentation';
		},
		allowRepairShopTab() {
			return (
				this.$store.getters.getDocumentsRepairShop &&
				this.$store.getters.getDocumentsRepairShop.length &&
				this.process.repairShop &&
				this.process.repairShop.id
			);
		},
		allowLawyerTab() {
			return (
				this.$store.getters.getDocumentsLawyer &&
				this.$store.getters.getDocumentsLawyer.length &&
				this.$store.getters.getDamageCase.lawyerOffice &&
				!this.isOrderDocumentation
			);
		},
		allowDamageAssessorTab() {
			return this.$store.getters.getDocumentsDamageAssessor && this.$store.getters.getDocumentsDamageAssessor.length && !this.isOrderDocumentation;
		},
		allowCustomerTab() {
			return this.$store.getters.getDocumentsCustomer && this.$store.getters.getDocumentsCustomer.length;
		},
		process() {
			return this.$store.getters.getDamageCase;
		},
	},
	methods: {
		fetchDocuments() {
			this.$store.dispatch('updateDocuments', { id: this.$route.params.processId });
		},
		add() {
			this.$store.commit('addDocument', { label: this.$t('choose_document'), set: 'misc', type: 'misc' });
		},
	},
	watch: {
		process: {
			handler: function() {
				this.$store.dispatch('updateDocuments');
			},
			deep: true,
			immediate: true,
		},
	},
};
</script>

<style scoped>
.tab {
	@apply cursor-pointer text-lg text-gray-500 font-bold;
}

.tab.active {
	@apply relative text-black;
}

.tab.active:after {
	content: '';
	height: 0.1rem;
	@apply absolute left-0 right-0 bottom-0 -mb-1 bg-connectProBlue;
}
</style>
